<div [class.map-n-outlets-selector]="uiContext.isSm()"
     [class.map-n-outlets-separated-selector]="!uiContext.isSm()">
  <div #outletListContainer class="outlets-selector"
       [class.show-border]="!onBackground">

    @if (uiContext.isSm()) {
    <div #simpleAccordionWrap>
      <ui-outlets-accordion
        [outlets]="outlets"
        [scheduleOverridesByOutletId]="scheduleOverridesByOutletId"
        [expandedOutlet]="expandedOutlet"
        [destinationPrefix]="destinationPrefix"
        [nextText]="nextText"
        [showNext]="showNext"
        [isOutletSelectionStateEnabled]="isOutletSelectionStateEnabled"
        [disabledOutletIds]="disabledOutletIds"
        [outletAccordionOptions]="outletAccordionOptions"
        [scheduleType]="scheduleType"
        (onNext)="onNext.emit($event)"
        (onScrollEmit)="simpleScrollToOutlet($event)"
        (onOutletChanged)="setMapOutlet($event)"
      ></ui-outlets-accordion>
    </div>
    }

    @if (!uiContext.isSm()) {
    <div class="outlets-mask-overlay"
         [class.mask-top]="!yReachStart && yReachEnd"
         [class.mask-bottom]="yReachStart && !yReachEnd"
         [class.mask-both]="!yReachStart && !yReachEnd"
         [class.mask-image-none]="!!selectedOnMapOutlet() || !isOutletsContainerOverflow"
         [style.font-family]="accordionFont">

      <div #outletScrollbar
           overlayScrollbars
           [options]="scrollbarOptions"
           [events]="scrollbarEvents"
           class="outlets-scroll-container">
        <div #outletAccordionWrap>
          <ui-outlets-accordion
            [isSeparatedView]="true"
            [outlets]="outlets"
            [scheduleOverridesByOutletId]="scheduleOverridesByOutletId"
            [destinationPrefix]="destinationPrefix"
            [nextText]="nextText"
            [showNext]="showNext"
            [isOutletSelectionStateEnabled]="isOutletSelectionStateEnabled"
            [outletAccordionOptions]="outletAccordionOptions"
            [scheduleType]="scheduleType"
            [disabledOutletIds]="disabledOutletIds"
            [expandedOutlet]="expandedOutlet"
            (onOutletChanged)="setMapOutlet($event)"
            (onNext)="onNext.emit($event)"
            (onScrollEmit)="perfectScrollToOutlet($event)"
          ></ui-outlets-accordion>
        </div>
      </div>
    </div>
    }
  </div>

  @if (!uiContext.isSm()) {
  <div class="outlets-map" #mapContainer>
    <ui-map-for-outlets-accordion
      [outlets]="outlets"
      [disabledIds]="disabledOutletIds"
      [initialMaxZoom]="initialMaxZoom"
      [shiftMapToRight]="shiftMapToRight"
      [selectedOutlet]="selectedOnMapOutlet()"
      (onSelectOutletOnMap)="setExpandedOutlet($event)"
    ></ui-map-for-outlets-accordion>
  </div>
  }
</div>
